import { Action, createReducer, on } from '@ngrx/store';
import { ProfileActions } from './profile.actions';
import { initialState, ProfileState } from './profile.state';
import { User } from '@core/models/entities/user.models';

const _profileReducer = createReducer(
  initialState,
  on(
    ProfileActions.saveUser,
    (state, { user }): ProfileState => ({
      ...state,
      user: user as User,
      error: null,
    })
  ),
  on(
    ProfileActions.getSubscriptionSuccess,
    (state, { subscriptions }): ProfileState => ({
      ...state,
      subscriptions: subscriptions,
      error: null,
    })
  ),
  on(
    ProfileActions.cancelSubscriptionSuccess,
    (state, { sub }): ProfileState => ({
      ...state,
      subscriptions: [...state.subscriptions.map(x => (x.id === sub.id ? sub : x))],
      error: null,
    })
  ),
  on(
    ProfileActions.clearUser,
    (state): ProfileState => ({
      ...state,
      user: null,
      error: null,
    })
  ),
  on(
    ProfileActions.error,
    (state, { error }): ProfileState => ({
      ...state,
      error,
    })
  )
);

export function profileReducer(state: ProfileState | undefined, action: Action) {
  return _profileReducer(state, action);
}
